import {
  Box,
  SortProvider,
  ModalProvider,
  SearchProvider,
  PaginationProvider,
  DropdownOptions,
  TooltipPopup,
} from 'dash-ui';

import Header from 'flow-components/Header/Header';
import Container from 'flow-components/Container/Container';

import {
  ExternalSalesUsersTable,
  ExternalSalesUsersHeader,
} from './components';

const ExternalSalesUsersPage = () => (
  <Box w="100%">
    <Header />
    <Container>
      <PaginationProvider>
        <SearchProvider>
          <SortProvider>
            <ModalProvider>
              <Box w="100%">
                <DropdownOptions />
                <TooltipPopup />
                <ExternalSalesUsersHeader />
                <ExternalSalesUsersTable />
              </Box>
            </ModalProvider>
          </SortProvider>
        </SearchProvider>
      </PaginationProvider>
    </Container>
  </Box>
);

export default ExternalSalesUsersPage;
